<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-card flat>
        <v-card-title>
          {{ $t('show_images_right_side') }}
          <v-spacer/>
          <!--          <v-btn v-show="computedValue.gallery && computedValue.gallery.length > 0" color="error" outlined-->
          <!--                 @click="computedValue.gallery = []">-->
          <!--            <v-icon class="ms-2">mdi-close-circle-outline</v-icon>-->
          <!--            حذف-->
          <!--          </v-btn>-->
        </v-card-title>

        <v-card-text>
          {{ $t('select_image') }}
          <pic-selector v-model="computedValue.gallery" :edit-img="false" :edit-name="false" single/>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import PicSelector from "../../../../components/UploadCenter/picSelector";

export default {
  name: "designSections",

  components: {PicSelector},

  props: {
    value: Object
  },

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style scoped>

</style>